import ForecastingTableController from './forecasting-table.controller';
import './forecasting-table.css';

const template = require<string>('./forecasting-table.html');

const frequencyTableComponent:ng.IComponentOptions = {
  bindings: {
  	'station': '<',
    'forecasts': '<',
    'forecastType': '<'
  },
  controller: ForecastingTableController,
  template
};
export default frequencyTableComponent;



/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/process/forecasting-table.component.ts
 **/